import bem from '../../../utils/bem';
import Icon from '../../Atoms/Icon/Icon';

const ProcessSteps = ({ steps, mods, extra }) => {
  const componentClassName = 'm-process-steps';

  return (
    <ul className={bem(componentClassName, mods, '', extra)}>
      {steps.map((step, i) => (
        <li className={bem('step', [], componentClassName)} key={i}>
          <span
            className={bem('status-icon', [], componentClassName, [
              step && 'is-active',
            ])}
          >
            <Icon iconName="checked" />
          </span>
        </li>
      ))}
    </ul>
  );
};

export default ProcessSteps;
